module.exports = __webpack_public_path__ + "static/media/forwardArrow.0e398eb1.svg";